import { lazy } from 'react';
const GatePassApproval = lazy(() => import('./GatePassApproval'));

const GatePassApprovalRoutes = [
  {
    path: '/gate-pass-approval',
    component: GatePassApproval
  }
];
export default GatePassApprovalRoutes;
